import { ApiResponse, postRequest } from "@/data/apiClient";

export interface ResetPasswordRequest {
  clientId: string;
  userId: number;
  resetToken: string;
  newPassword: string;
}

export interface ResetPasswordResponse {
  ok: boolean;
  errorType: string;
  errorMessage: string;
}

export async function resetPassword(
  req: ResetPasswordRequest
): Promise<ApiResponse<ResetPasswordResponse>> {
  return postRequest("user/resetPassword", req);
}
